export const WHATSAPP_NUMBER = '917409508399';
export const INSTAGRAM_URL = 'https://www.instagram.com/yogicsoul_ranj?igsh=c2h4d3pibGVtZjQw';
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;
